import react, { Fragment } from "react";

export default function ErrorMessage({ errors }) {

    const getError = (e) => {
        return (<div className="row">
            {e.label && <div className="col-4 fw-bold">{e.label}</div>}
            {e.message && <div className="col">{e.message}</div>}
            {e.messages && <div className="col">{e.messages.join(';')}</div>}
            {!e.label && !e.message && !e.messages && <div className="col">{e}</div>}
        </div>);
    }

    return (<div className="text-danger m-0">
        {errors.map((e, index) => {
            return (<div key={index + '_error_message'}>
                {!Array.isArray(e) && getError(e)}
                {Array.isArray(e) && e.map((se, i) => {
                    return (<Fragment key={index + '_' + i + '_sub_error_message'}>
                        {getError(se)}
                    </Fragment>)
                })}
            </div>);
        })}
    </div>);
}